import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Search } from '@safedns/skydns-ui-react-lib';

const SearchInput = ({ placeholder, cb, sx }) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const searchHandler = (e) => {
    setSearch(e.target.value);
    dispatch(cb(e.target.value));
  };

  const clearField = () => {
    setSearch('');
    dispatch(cb(''));
  };

  return (
    <Search
      value={search}
      isClearButton
      isLensIconVisible
      placeholder={placeholder}
      onClear={clearField}
      onChange={searchHandler}
      sx={{ ...sx }}
    />
  );
};

export default SearchInput;
